<template>
    <div>
        <el-tooltip placement="top" :popper-class="!show ? 'hide-tooltip el-tooltip-max-height-set' : 'show-tooltip el-tooltip-max-height-set'">
            <div slot="content" style="max-width: 800px;max-height: 50vh;overflow-y: auto;">
                <div v-html="tipContent"></div>
            </div>
            <span class="multiline-ellipsis"
                  @mouseenter.stop.prevent="onMouseOver"
                  @mouseleave.stop.prevent="onMouseLeave"
            >
                {{text}}
            </span>
        </el-tooltip>
    </div>
</template>
<script>
import {throttle} from 'lodash'
import {ellipseShowPromise} from '@/utils'
export default {
    name: 'hoverEllipsis',
    props:['text', 'toHtml'],
    data() {
        return {
            show: false,
            tipContent:''
        }
    },
    // watch: {
    //   'toHtml': {
    //       handler(n) {
    //           if(n == 'account') {
    //               this.tipContent = this.text && this.text.replace(/；/g, '<br>')
    //           }else{
    //               this.tipContent = this.text
    //           }
    //       },
    //       deep: true,
    //       immediate: true
    //   }
    // },
    mounted() {
        if(this.toHtml === 'account') {
            this.tipContent = this.text && this.text.replace(/；/g, '<br>')
        }else{
            this.tipContent = this.text
        }
    },
    methods:{
        onMouseOver: throttle(function (e) {
            ellipseShowPromise(e.target, false, false).then(hasEllipsis => {
                this.$nextTick(()=>{
                    if(hasEllipsis) {
                        this.show = true
                    } else {
                        this.show = false
                    }
                })
            });
        }, 1000),
        onMouseLeave: throttle(function () {
            // this.show = false
        },1000)
    }
}
</script>
<style lang="scss" scoped>
.multiline-ellipsis {
    position: relative;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

</style>
<style lang="scss">
.hide-tooltip {
    visibility: hidden;
}
.el-tooltip-max-height-set{
    &.el-tooltip__popper[role="tooltip"]{
        max-width: 1000px !important;
    }
}
</style>
